export default {
    state: () => ({
        toasts: [],
        toastDuration: 3000,
    }),
    mutations: {
        addToasts(state, toast) {
            state.toasts.push(toast);
        },
        removeToast(state, toast) {
            const index = state.toasts.indexOf(toast);
            if (index > -1) {
                state.toasts.splice(index, 1);
            }
        },
    },
    actions: {
        showToast({state, commit}, {message, type, amount = 0}) {
            const toast = {
                message: message,
                type: type,
                amount: amount
            };
            commit("addToasts", toast);
            setTimeout(() => {
                commit("removeToast", toast);
            }, state.toastDuration);
        },
        closeToast({commit}, toast) {
            commit("removeToast", toast);
        },
        closeAllToasts({commit}) {
            commit("setToasts", []);
        },
    },
    namespaced: true,
};
